import { Component, AfterViewInit, OnDestroy } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { InsaService, LocalizeService } from '../../insa-services'
import { KendoColumnDefinition, TransactionModel, ClientModel } from '../../insa-models'
import { appStateProvider } from '../../insa-providers'
import { appConfig } from '../../../insaweb.config'
import { customGroupHeader, SharedMethodsModule, CustomGridFilterModule } from '../../insa-custom-scripts'

@Component({
    template: '<button type="button" (click)="exportToExcel()" class="excelExportBtn" alt="Excel Export"><svg id="exportxls" data-name="exportxls" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60"><title>Excel Export</title><path class="cls-4" d="M52.31,34V7.57h-45v45H18.91c0-2.76,0-2.92,0-5l-6.56,0v-35h35l0,21.4Z"/><polygon class="cls-4" points="22.48 47.57 37.29 47.57 37.29 52.22 52.48 42.92 37.29 33.61 37.29 38.27 22.48 38.27 22.48 47.57"/><path class="cls-4" d="M27.08,28.33H24.89l-2.26-4a4.06,4.06,0,0,1-.22-.52h0l-.23.52-2.33,4H17.61l3.61-5.54-3.32-5.48h2.24l2,3.72q.19.37.35.74h0q.22-.48.38-.77L25,17.31H27l-3.4,5.47Z"/><polygon class="cls-4" points="34.69 28.33 28.59 28.33 28.59 17.31 30.42 17.31 30.42 26.79 34.69 26.79 34.69 28.33"/><path class="cls-4" d="M35.78,27.89V26a2.91,2.91,0,0,0,.6.42,4.66,4.66,0,0,0,.74.31,5.85,5.85,0,0,0,.78.2,4.18,4.18,0,0,0,.72.07,3.08,3.08,0,0,0,1.72-.38,1.26,1.26,0,0,0,.56-1.11,1.22,1.22,0,0,0-.19-.68,2,2,0,0,0-.53-.53,5.53,5.53,0,0,0-.8-.46l-1-.46q-.56-.3-1-.61a4.5,4.5,0,0,1-.84-.68,2.85,2.85,0,0,1-.56-.84,2.74,2.74,0,0,1-.2-1.1,2.54,2.54,0,0,1,.35-1.35,3,3,0,0,1,.92-.95,4.23,4.23,0,0,1,1.3-.55,6.19,6.19,0,0,1,1.49-.18,6,6,0,0,1,2.52.39v1.81a4,4,0,0,0-2.41-.68,4.32,4.32,0,0,0-.81.08,2.41,2.41,0,0,0-.72.25,1.56,1.56,0,0,0-.52.45,1.11,1.11,0,0,0-.2.67,1.26,1.26,0,0,0,.15.64,1.65,1.65,0,0,0,.45.49,4.59,4.59,0,0,0,.72.43l1,.46q.58.3,1.09.63a5.13,5.13,0,0,1,.9.73,3.21,3.21,0,0,1,.61.89,2.61,2.61,0,0,1,.23,1.11,2.61,2.61,0,0,1-1.25,2.35,4.06,4.06,0,0,1-1.32.52,7.43,7.43,0,0,1-1.58.16,6.71,6.71,0,0,1-.68,0q-.4,0-.83-.12a7.6,7.6,0,0,1-.8-.2A2.53,2.53,0,0,1,35.78,27.89Z"/></svg></button><div class="canvas gridResize"><div id="TransactionsGrid" (window:resize)="onResize($event)" class="transGrid-loading"></div></div>'
})
export class TransactionsComponent implements AfterViewInit, OnDestroy {

    private gridName = 'TransactionsGrid'
    private transSubscription;

    constructor(private _insaService: InsaService, private _appStateProvider: appStateProvider, private _localize: LocalizeService, private route: ActivatedRoute) {
        let routeSnapshot = this.route.snapshot;

        if (routeSnapshot.queryParamMap.has('PartnerID')) {
            this._appStateProvider.selectedPartner = { value: Number.parseInt(routeSnapshot.queryParamMap.get('PartnerID')), text: "Self" };
        }
        if (routeSnapshot.queryParamMap.has('portfolios')) {
            var array = routeSnapshot.queryParamMap.get('portfolios').split(",");
            var intArray = new Array<any>();
            routeSnapshot.queryParamMap.get('portfolios').split(",").map(portf => {
                intArray.push(Number.parseInt(portf));
            })
            this._appStateProvider.selectedPortfolios = intArray;
        }
        if (routeSnapshot.queryParamMap.has('fromDate')) {
            this._appStateProvider.startDate = new Date(routeSnapshot.queryParamMap.get('fromDate'));
        }
        if (routeSnapshot.queryParamMap.has('toDate')) {
            this._appStateProvider.endDate = new Date(routeSnapshot.queryParamMap.get('toDate'));
        }

        this.transSubscription = this._insaService.TransactionsChangedEvent.subscribe(transactions => {
            this.refreshTransactions(transactions);
            //this.InitKendoTransactionsGrid(this.createTransactionGridColumnDefs(transactions), transactions);
        });

        if ((this._appStateProvider.selectedPartners && this._appStateProvider.selectedPartner.value != 0) || (this._appStateProvider.selectedPortfolios && this._appStateProvider.selectedPortfolios.length > 0)) {
            if (!this._appStateProvider.fetchingTransactions) {
                this._insaService.getTransactions();
            }
        }
    }

    private exportToExcel() {
        let transGrid: any = $("#TransactionsGrid");
        if (transGrid !== undefined) {
            transGrid.getKendoGrid().saveAsExcel();
        }
    }

    private refreshTransactions(transactions: TransactionModel[]) {
        kendo.ui.progress($(".transGrid-loading"), this._appStateProvider.fetchingTransactions);
        if (transactions !== undefined && transactions !== null && transactions.length > 0) {
            this.InitKendoTransactionsGrid(this.createTransactionGridColumnDefs(), transactions);
        } else {
            this.InitKendoTransactionsGrid(this.createTransactionGridColumnDefs(), []);
        }
    }

    private createTransactionGridColumnDefs() {

        let TransactionGridColumnDefs = new Array<KendoColumnDefinition>();
        let aggregateTemplate: string = "<div style='float: right'>#= (sum!==null) ? kendo.toString(sum, 'n2') : '' #</div>";

        //if(transactions!==undefined && transactions!==null) {
        //if (transactions[0].SecName !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("SecName", this._localize.getLocalizedResource('Res3516'), '#:(SecName!==null) ? SecName : "" #'));
        //}
        //if (transactions[0].SecISIN !== undefined){
        //TransactionGridColumnDefs.push(new KendoColumnDefinition("SecISIN", this._localize.getLocalizedResource('Res960'),'#:(SecISIN!==null) ? SecISIN : "" #'));
        //}
        // if (transactions[0].TransDate !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("TransDate", this._localize.getLocalizedResource('Res704'), '#: (TransDate!==null)? kendo.toString(TransDate, "dd.MM.yyyy"): ""#'));
        // }
        // if (transactions[0].ValueDate !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("ValueDate", this._localize.getLocalizedResource('Res707'), '#: (ValueDate!==null)? kendo.toString(ValueDate, "dd.MM.yyyy"): ""#'));
        // }
        //if (transactions[0].TransTypeDescription !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("TransTypeDescription", this._localize.getLocalizedResource('Res3235'), '#: (TransTypeDescription!==null) ? TransTypeDescription : "" #'));
        //}
        //if (transactions[0].QuantityWithoutCash !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("QuantityWithoutCash", this._localize.getLocalizedResource('Res688'), '#: (QuantityWithoutCash!==null) ? kendo.toString(QuantityWithoutCash, "n2"): "" #', '{0:#.##}', false, false));
        // }
        // if (transactions[0].Description !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("Description", this._localize.getLocalizedResource('Res542'), '#:(Description!==null) ? Description : ""#'));
        //}
        // if (transactions[0].Price !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("Price", this._localize.getLocalizedResource('Res711'), '#: (Price!==null) ? kendo.toString(Price, "n2"): "" #', '{0:#.##}', false));
        //}
        //if (transactions[0].SecNumber !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("SecNumber", this._localize.getLocalizedResource('Res708'), '#:(SecNumber!==null) ? SecNumber : "" #'));
        //}
        // 'Ref. Currency'
        //if (transactions[0].ClientRefCurr !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("ClientRefCurr", this._localize.getLocalizedResource('Res1033'), '#:(ClientRefCurr!==null) ? ClientRefCurr : "" #'));
        // }
        // 'Amount Ref. Currency'
        //if (transactions[0].TransAmountRC !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("TransAmountRC", this._localize.getLocalizedResource('Res2480'), '#: (TransAmountRC!==null) ? kendo.toString(TransAmountRC, "n2"): "" #', '{0:#.##}', false, false, ["sum"], aggregateTemplate, aggregateTemplate));
        //}
        // 'Sec. Currency'
        // if (transactions[0].SecurityCurrency !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("SecurityCurrency", this._localize.getLocalizedResource('Res724'), '#:(SecurityCurrency!==null) ? SecurityCurrency : "" #'));
        //}
        // 'Amount Sec. Currency' --> Total (SC)
        //if (transactions[0].TransAmountSC !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("TransAmountSC", this._localize.getLocalizedResource('Res718'), '#: (TransAmountSC!==null) ? kendo.toString(TransAmountSC, "n2"): "" #', '{0:#.##}', false));
        //}
        //if (transactions[0].AccountCurrency !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("AccountCurrency", this._localize.getLocalizedResource('Res577'), '#: (AccountCurrency!==null) ? AccountCurrency : ""#'));
        //}
        //  'Amount Account Currency' --> Total (AC)
        //if (transactions[0].TransAmountAC !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("TransAmountAC", this._localize.getLocalizedResource('Res720'), '#: (TransAmountAC!==null) ? kendo.toString(TransAmountAC, "n2"): ""#', '{0:#.##}', false));
        // }
        // if (transactions[0].AccountNumber !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("AccountNumber", this._localize.getLocalizedResource('Res702'), '#: (AccountNumber!==null) ? AccountNumber: "" #'));
        // }
        // 'Deposit Number' --> Res1080 Custody Account
        //if (transactions[0].DepotNumber !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("DepotNumber", this._localize.getLocalizedResource('Res1080'), '#: (DepotNumber!==null) ? DepotNumber: "" #'));
        //}
        //if (transactions[0].ClientNumber !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("ClientNumber", this._localize.getLocalizedResource('Res270'), '#: (ClientNumber!==null) ? ClientNumber: "" #'));
        //}
        // if (transactions[0].Commision !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("Commision", this._localize.getLocalizedResource('Res1271'), '#: (Commision!==undefined && Commision!==null) ? kendo.toString(Commision, "n2"): "" #', '', false, false, ["sum"], aggregateTemplate, aggregateTemplate));
        // }
        //if (transactions[0].StampDuty !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("StampDuty", this._localize.getLocalizedResource('Res617'), '#: (StampDuty!==undefined && StampDuty!==null) ? kendo.toString(StampDuty, "n2"): "" #', '', false, false, ["sum"], aggregateTemplate, aggregateTemplate));
        //}
        // if (transactions[0].Expenses !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("Expenses", this._localize.getLocalizedResource('Res717'), '#: (Expenses!==undefined && Expenses!==null) ? kendo.toString(Expenses, "n2"): "" #', '', false, false, ["sum"], aggregateTemplate, aggregateTemplate));
        //}
        //if (transactions[0].AccruedInterest !== undefined){
        TransactionGridColumnDefs.push(new KendoColumnDefinition("AccruedInterest", this._localize.getLocalizedResource('Res862'), '#: (AccruedInterest!==undefined && AccruedInterest!==null) ? kendo.toString(AccruedInterest, "n2"): "" #', '', false, false, ["sum"], aggregateTemplate, aggregateTemplate));

        TransactionGridColumnDefs.push(new KendoColumnDefinition("ForeignExpensesRef", this._localize.getLocalizedResource('Res713'), '#: (ForeignExpensesRef!==undefined && ForeignExpensesRef!==null) ? kendo.toString(ForeignExpensesRef, "n2"): "" #', '', false, false));
        TransactionGridColumnDefs.push(new KendoColumnDefinition("StockExchangeTaxRef", this._localize.getLocalizedResource('Res716'), '#: (StockExchangeTaxRef!==undefined && StockExchangeTaxRef!==null) ? kendo.toString(StockExchangeTaxRef, "n2"): "" #', '', false, false));
        TransactionGridColumnDefs.push(new KendoColumnDefinition("EuroTaxRef", this._localize.getLocalizedResource('Res431'), '#: (EuroTaxRef!==undefined && EuroTaxRef!==null) ? kendo.toString(EuroTaxRef, "n2"): "" #', '', false, false));
        TransactionGridColumnDefs.push(new KendoColumnDefinition("NonReclaimableTaxRef", this._localize.getLocalizedResource('Res729'), '#: (NonReclaimableTaxRef!==undefined && NonReclaimableTaxRef!==null) ? kendo.toString(NonReclaimableTaxRef, "n2"): "" #', '', false, false));
        TransactionGridColumnDefs.push(new KendoColumnDefinition("ReclaimableTaxRef", this._localize.getLocalizedResource('Res730'), '#: (ReclaimableTaxRef!==undefined && ReclaimableTaxRef!==null) ? kendo.toString(ReclaimableTaxRef, "n2"): "" #', '', false, false));

        this.setPropertiesForTransactionsGrid(TransactionGridColumnDefs);
        this.setGroupHeaderTemplate(TransactionGridColumnDefs);

        return TransactionGridColumnDefs;
        // }
    }

    private setGroupHeaderTemplate(arr: Array<KendoColumnDefinition>) {
        arr.forEach(element => {
            element.groupHeaderTemplate = "#= getGroupInfo(aggregates,data, getKendoGrid('TransactionsGrid')) #";
        });
    }

    private setPropertiesForTransactionsGrid(kendoColumn) {
        let columnStyleLeftAlign: any = { style: "font-size:1rem;text-transform:none;" };
        let headerStyleLeftAlign: any = { style: "text-transform:none;" };
        let columnStyleRightAlign: any = { style: "text-align:right;font-size:1rem;text-transform:none;" };
        let headerStyleRightAlign: any = { style: "text-align:right;text-transform:none;" };

        for (let i = 0; i < kendoColumn.length; i++) {

            switch (kendoColumn[i].field) {
                case "TransAmountAC":
                    kendoColumn[i].attributes = columnStyleRightAlign;
                    kendoColumn[i].headerAttributes = headerStyleRightAlign;
                    kendoColumn[i].width = 210;
                    kendoColumn[i].groupable = false;
                    break;
                case "ClientNumber":
                    kendoColumn[i].attributes = columnStyleLeftAlign;
                    kendoColumn[i].headerAttributes = headerStyleLeftAlign;
                    kendoColumn[i].width = 150;
                    break;
                case "SecurityCurrency":
                    kendoColumn[i].attributes = columnStyleLeftAlign;
                    kendoColumn[i].headerAttributes = headerStyleLeftAlign;
                    kendoColumn[i].width = 130;
                    break;
                case "ValueDate":
                    kendoColumn[i].attributes = columnStyleLeftAlign;
                    kendoColumn[i].headerAttributes = headerStyleLeftAlign;
                    kendoColumn[i].width = 190;
                    break;
                case "TransDate":
                    kendoColumn[i].attributes = columnStyleLeftAlign;
                    kendoColumn[i].headerAttributes = headerStyleLeftAlign;
                    kendoColumn[i].width = 200;
                    break;
                case "SecName":
                    kendoColumn[i].attributes = columnStyleLeftAlign;
                    kendoColumn[i].headerAttributes = headerStyleLeftAlign;
                    kendoColumn[i].width = 300;
                    break;
                case "SecNumber":
                    kendoColumn[i].attributes = columnStyleLeftAlign;
                    kendoColumn[i].headerAttributes = headerStyleLeftAlign;
                    break;
                case "ClientRefCurr":
                    kendoColumn[i].attributes = columnStyleLeftAlign;
                    kendoColumn[i].headerAttributes = headerStyleLeftAlign;
                    kendoColumn[i].width = 150;
                    break;
                case "QuantityWithoutCash":
                    kendoColumn[i].attributes = columnStyleRightAlign;
                    kendoColumn[i].headerAttributes = headerStyleRightAlign;
                    kendoColumn[i].width = 110;
                    kendoColumn[i].groupable = false;
                    break;
                case "AccountCurrency":
                    kendoColumn[i].attributes = columnStyleLeftAlign;
                    kendoColumn[i].headerAttributes = headerStyleLeftAlign;
                    kendoColumn[i].width = 200;
                    break;
                case "TransTypeDescription":
                    kendoColumn[i].attributes = columnStyleLeftAlign;
                    kendoColumn[i].headerAttributes = headerStyleLeftAlign;
                    break;
                case "TransAmountSC":
                    kendoColumn[i].attributes = columnStyleRightAlign;
                    kendoColumn[i].headerAttributes = headerStyleRightAlign;
                    kendoColumn[i].width = 180;
                    kendoColumn[i].groupable = false;
                    break;
                case "TransAmountRC":
                    kendoColumn[i].attributes = columnStyleRightAlign;
                    kendoColumn[i].headerAttributes = headerStyleRightAlign;
                    kendoColumn[i].width = 200;
                    kendoColumn[i].groupable = false;
                    break;
                case "Price":
                    kendoColumn[i].attributes = columnStyleRightAlign;
                    kendoColumn[i].headerAttributes = headerStyleRightAlign;
                    kendoColumn[i].width = 90;
                    kendoColumn[i].groupable = false;
                    break;
                case "AccountNumber":
                    kendoColumn[i].attributes = columnStyleLeftAlign;
                    kendoColumn[i].headerAttributes = headerStyleLeftAlign;
                    kendoColumn[i].width = 200;
                    break;
                case "DepotNumber":
                    kendoColumn[i].attributes = columnStyleLeftAlign;
                    kendoColumn[i].headerAttributes = headerStyleLeftAlign;
                    kendoColumn[i].width = 200;
                    break;
                case "Description":
                    kendoColumn[i].attributes = columnStyleLeftAlign;
                    kendoColumn[i].headerAttributes = headerStyleLeftAlign;
                    break;
                case "Commision":
                    kendoColumn[i].attributes = columnStyleRightAlign;
                    kendoColumn[i].headerAttributes = headerStyleRightAlign;
                    kendoColumn[i].groupable = false;
                    break;
                case "StampDuty":
                    kendoColumn[i].attributes = columnStyleRightAlign;
                    kendoColumn[i].headerAttributes = headerStyleRightAlign;
                    kendoColumn[i].groupable = false;
                    break;
                case "Expenses":
                    kendoColumn[i].attributes = columnStyleRightAlign;
                    kendoColumn[i].headerAttributes = headerStyleRightAlign;
                    kendoColumn[i].groupable = false;
                    break;
                case "AccruedInterest":
                    kendoColumn[i].attributes = columnStyleRightAlign;
                    kendoColumn[i].headerAttributes = headerStyleRightAlign;
                    kendoColumn[i].groupable = false;
                    break;
                case "ForeignExpensesRef":
                    kendoColumn[i].attributes = columnStyleRightAlign;
                    kendoColumn[i].headerAttributes = headerStyleRightAlign;
                    kendoColumn[i].groupable = false;
                    break;
                case "StockExchangeTaxRef":
                    kendoColumn[i].attributes = columnStyleRightAlign;
                    kendoColumn[i].headerAttributes = headerStyleRightAlign;
                    kendoColumn[i].groupable = false;
                    break;
                case "EuroTaxRef":
                    kendoColumn[i].attributes = columnStyleRightAlign;
                    kendoColumn[i].headerAttributes = headerStyleRightAlign;
                    kendoColumn[i].groupable = false;
                    break;
                case "NonReclaimableTaxRef":
                    kendoColumn[i].attributes = columnStyleRightAlign;
                    kendoColumn[i].headerAttributes = headerStyleRightAlign;
                    kendoColumn[i].groupable = false;
                    break;
                case "ReclaimableTaxRef":
                    kendoColumn[i].attributes = columnStyleRightAlign;
                    kendoColumn[i].headerAttributes = headerStyleRightAlign;
                    kendoColumn[i].groupable = false;
                    break;
                default: console.log("");
            }
        }
    }

    private hideColumnsDependingOnScreenSize(gridWidth) {
        let kendoTransGrid: kendo.ui.Grid = $("#TransactionsGrid").data("kendoGrid");
        let colVisibilityChanged: boolean = false;
        if (gridWidth < 970) {
            kendoTransGrid.columns.forEach(col => {
                if (!appConfig.transactionsGridSmallScreenColumns.includes(col.field) && !appConfig.clientSpecificColumnHidden.includes(col.field)) {
                    if (!col.hidden) colVisibilityChanged = true;
                    kendoTransGrid.hideColumn(col);
                }
            });
        } else {
            kendoTransGrid.columns.forEach(col => {
                if (!appConfig.clientSpecificColumnHidden.includes(col.field)) {
                    if (col.hidden) colVisibilityChanged = true;
                    kendoTransGrid.showColumn(col);
                } else {
                    kendoTransGrid.hideColumn(col);
                }
            });
        }

        if (colVisibilityChanged) {
            kendoTransGrid.refresh();
            $("#TransactionsGrid").find(".k-icon.k-i-collapse").trigger("click");
            colVisibilityChanged = false;
        }
    }

    private onResize(event) {
        let transGrid: kendo.ui.Grid = $("#TransactionsGrid").data("kendoGrid");
        this.hideColumnsDependingOnScreenSize(event.target.innerWidth);
        if (transGrid !== undefined) {
            transGrid.options.height = $(".gridResize").height();
            transGrid.resize();
        }
    }

    private InitKendoTransactionsGrid(columnDefs, griddata) {
        let dataSourceOptions: kendo.data.DataSourceOptions = {};
        dataSourceOptions.data = griddata;
        dataSourceOptions.group = [{
            field: "TransTypeDescription", aggregates: [
                { field: "AccruedInterest", aggregate: "sum" },
                { field: "StampDuty", aggregate: "sum" },
                { field: "Expenses", aggregate: "sum" },
                { field: "Commision", aggregate: "sum" },
                { field: "TransAmountRC", aggregate: "sum" }]
        }];
        dataSourceOptions.aggregate = [
            { field: "AccruedInterest", aggregate: "sum" },
            { field: "StampDuty", aggregate: "sum" },
            { field: "Expenses", aggregate: "sum" },
            { field: "Commision", aggregate: "sum" },
            { field: "TransAmountRC", aggregate: "sum" }];
        dataSourceOptions.schema = {
            model: {
                fields: {
                    SecName: { type: "string" },
                    TransDate: { type: "date" },
                    ValueDate: { type: "date" },
                    TransTypeDescription: { type: "string" },
                    QuantityWithoutCash: { type: "number" },
                    Description: { type: "string" },
                    Price: { type: "number" },
                    SecNumber: { type: "string" },
                    ClientRefCurr: { type: "string" },
                    TransAmountRC: { type: "number" },
                    TransAmountAC: { type: "number" },
                    TransAmountSC: { type: "number" },
                    SecurityCurrency: { type: "string" },
                    AccountCurrency: { type: "string" },
                    AccountNumber: { type: "string" },
                    DepotNumber: { type: "string" },
                    ClientNumber: { type: "string" },
                    Commision: { type: "number" },
                    StampDuty: { type: "number" },
                    Expenses: { type: "number" },
                    AccruedInterest: { type: "number" },
                    ForeignExpensesRef: { type: "number" },
                    StockExchangeTaxRef: { type: "number" },
                    EuroTaxRef: { type: "number" },
                    NonReclaimableTaxRef: { type: "number" },
                    ReclaimableTaxRef: { type: "number" }
                }
            }
        };

        let dataSource: kendo.data.DataSource = new kendo.data.DataSource(dataSourceOptions);
        let transGrid: kendo.ui.Grid = $("#TransactionsGrid").data("kendoGrid");

        if (transGrid === undefined) {
            let transGridOptions: kendo.ui.GridOptions = {};
            transGridOptions.dataSource = dataSource;
            transGridOptions.excel = {
                fileName: "Transactions.xlsx",
                filterable: true,
                allPages: true
            };
            transGridOptions.excelExport = function (e) {
                let sheet = e.workbook.sheets[0];
                for (let i = 0; i < sheet.rows.length; i++) {
                    /* if(sheet.rows[i]["type"]==="header"){
                         for (var ci = 0; ci < sheet.rows[i].cells.length; ci++) {
                            if(sheet.rows[i].cells[ci].value === "Expenses") {
                             sheet.rows[i].cells[ci].value = <any>sheet.rows[i].cells[ci].value * 100; 
                            } 
                         }
                     }*/
                    if (sheet.rows[i]["type"] === "group-header" || sheet.rows[i]["type"] === "group-footer" || sheet.rows[i]["type"] === "footer") {
                        sheet.rows[i].cells.reverse();
                        for (var ci = 0; ci < sheet.rows[i].cells.length; ci++) {
                            if (sheet.rows[i].cells[ci].value !== undefined) {
                                sheet.rows[i].cells[ci].hAlign = "right";
                                /*if(sheet.rows[i].cells[ci].value!== undefined && !isNaN(<any>sheet.rows[i].cells[ci].value))
                                {
                                   sheet.rows[i].cells[ci].hAlign = "right";
                                }*/
                                sheet.rows[i].cells[ci].value = $($.parseHTML(<any>sheet.rows[i].cells[ci].value))[0].innerText;
                            }
                        }
                    }
                }
            };
            transGridOptions.filterable = true;
            //transGridOptions.height = '100%';
            transGridOptions.sortable = true;
            transGridOptions.selectable = true;
            transGridOptions.reorderable = true;
            transGridOptions.scrollable = true;
            transGridOptions.noRecords = { template: "<p class='center no-data-message'>NO DATA</p>" };
            transGridOptions.groupable = true;
            transGridOptions.group = function (e) {
                if (e.groups !== undefined && e.groups !== null) {
                    let lastSavedGrouping = e.groups;
                    localStorage.setItem('transGridGrouping', JSON.stringify(lastSavedGrouping));
                }
            };
            transGridOptions.sort = function (e) {
                if (e.sort !== undefined && e.sort !== null) {
                    let lastSavedSorting = e.sort;
                    localStorage.setItem('transGridSorting', JSON.stringify(lastSavedSorting));
                }
            };
            transGridOptions.pageable = false;
            transGridOptions.resizable = true;
            transGridOptions.columns = columnDefs;
            transGridOptions.columnReorder = customGroupHeader.gridColumnReorder;
            transGridOptions.dataBound = customGroupHeader.KendoGridDataBound;
            if (window.innerWidth > 768) {
                transGridOptions.filterMenuInit = CustomGridFilterModule.onFilterMenuInit;
            }

            SharedMethodsModule.saveGridOptionsOnChange(transGridOptions, this.gridName)
            const savedOptions = SharedMethodsModule.getSavedGridOptions(columnDefs, this.gridName)
            const combinedGridOptions = SharedMethodsModule.combineGridInitOptions(savedOptions, transGridOptions)
            $("#TransactionsGrid").kendoGrid(combinedGridOptions);
            transGrid = $("#TransactionsGrid").data("kendoGrid");

            if (savedOptions && savedOptions.dataSource) {
                $('#' + this.gridName).data('kendoGrid').dataSource.group(savedOptions.dataSource.group)
                $('#' + this.gridName).data('kendoGrid').dataSource.sort(savedOptions.dataSource.sort)
            }
        } else {
            $("#TransactionsGrid").data("kendoGrid").setDataSource(dataSource);
        }

        transGrid.thead.find("[data-field=QuantityWithoutCash]>.k-header-column-menu").remove();
        transGrid.thead.find("[data-field=Price]>.k-header-column-menu").remove();
        transGrid.thead.find("[data-field=TransAmountAC]>.k-header-column-menu").remove();
        transGrid.thead.find("[data-field=TransAmountSC]>.k-header-column-menu").remove();
        transGrid.thead.find("[data-field=Commision]>.k-header-column-menu").remove();
        transGrid.thead.find("[data-field=Expenses]>.k-header-column-menu").remove();
        transGrid.thead.find("[data-field=StampDuty]>.k-header-column-menu").remove();
        transGrid.thead.find("[data-field=AccruedInterest]>.k-header-column-menu").remove();
        if (appConfig.sortTransactionsByDefault) transGrid.thead.find('[data-field=TransDate] >.k-link').trigger('click');
        SharedMethodsModule.loadGridGroupingAndSorting("TransactionsGrid");

    }

    ngAfterViewInit() {
        kendo.ui.progress($(".transGrid-loading"), this._appStateProvider.fetchingTransactions);
        if (this._insaService.transactions !== undefined && this._insaService.transactions !== null) {
            this.refreshTransactions(this._insaService.transactions);
            //this.InitKendoTransactionsGrid(this.createTransactionGridColumnDefs(this._insaService.transactions), this._insaService.transactions);
            this.hideColumnsDependingOnScreenSize(window.innerWidth);
        }

    }

    ngOnDestroy() {
        this.transSubscription.unsubscribe();
    }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-grids/transactions.component.ts